import { Container, Title, Text, Stack, Divider, Anchor } from '@mantine/core';

export default function TermsOfService() {
  return (
    <Container size="md" py="xl">
      <Stack gap="lg">
        <Title order={1}>Terms of Service</Title>
        <Text c="dimmed" size="sm">Last updated: April 3, 2026</Text>

        <Divider />

        <Title order={3}>1. Acceptance of Terms</Title>
        <Text>
          By accessing or using the FreshOps platform and services provided by Standard
          Produce Company ("Standard Produce", "we", "us"), you agree to be bound by
          these Terms of Service. These terms apply to all B2B customers, portal users,
          and SMS subscribers.
        </Text>

        <Title order={3}>2. Services</Title>
        <Text>
          Standard Produce provides wholesale produce distribution services, including:
          online ordering via the FreshOps portal, SMS-based ordering, delivery scheduling,
          account management, invoicing, and payment processing.
        </Text>

        <Title order={3}>3. Accounts</Title>
        <Text>
          Business accounts are created by Standard Produce after completing our customer
          onboarding process. You are responsible for maintaining the confidentiality of
          your account credentials and for all activity under your account.
        </Text>

        <Title order={3}>4. Orders and Pricing</Title>
        <Text>
          All orders are subject to product availability. Prices are determined by current
          market conditions and your account terms. We reserve the right to adjust pricing
          with reasonable notice. Orders placed via SMS, phone, or the portal are binding
          once confirmed.
        </Text>

        <Title order={3}>5. Payment Terms</Title>
        <Text>
          Payment terms are established per your credit application and account agreement.
          Standard terms are Net 30 unless otherwise specified. Late payments may incur
          finance charges as outlined in your account agreement.
        </Text>

        <Title order={3}>6. SMS Services</Title>
        <Text>
          Our SMS ordering and notification service is governed by separate{' '}
          <Anchor href="/sms-terms" inherit>SMS Terms of Service</Anchor>. By opting in to
          SMS, you agree to receive transactional messages related to your orders, deliveries,
          and account. Standard message and data rates apply.
        </Text>

        <Title order={3}>7. Limitation of Liability</Title>
        <Text>
          Standard Produce's liability is limited to the value of the affected order.
          We are not liable for indirect, consequential, or incidental damages. Produce
          is perishable and we cannot guarantee specific shelf life after delivery.
        </Text>

        <Title order={3}>8. Governing Law</Title>
        <Text>
          These terms are governed by the laws of the Commonwealth of Virginia. Any
          disputes shall be resolved in the courts of Charlottesville, Virginia.
        </Text>

        <Title order={3}>9. Changes to Terms</Title>
        <Text>
          We may modify these terms at any time. Material changes will be communicated
          to active customers via email or portal notification at least 30 days before
          taking effect.
        </Text>

        <Title order={3}>10. Contact</Title>
        <Text>
          Standard Produce Company{'\n'}
          Charlottesville, VA{'\n'}
          Phone: (434) 204-2184{'\n'}
          Email: info@standardproduce.com
        </Text>
      </Stack>
    </Container>
  );
}
